//
// The number of approvals the signed-in user can decide now (GET approvals/mine), for the badge of the Approvals
// entry in the main menu. One store for every menu instance on the page; usePendingApprovalsPoller loads it, and any
// screen that changes the queue (a decision, an approval event of the hub) asks for a refresh.
//

let pendingCount: number | undefined = undefined;
const listeners = new Set<() => void>();
let refresher: (() => void) | undefined = undefined;

export const subscribePendingApprovals = (listener: () => void): (() => void) => {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
};

// undefined until the first load, and for a user who has no queue
export const getPendingApprovalCount = (): number | undefined => pendingCount;

export const setPendingApprovalCount = (count: number | undefined): void => {
  if (count === pendingCount) return;

  pendingCount = count;
  listeners.forEach((listener) => listener());
};

// The poller registers the load; the returned function removes it again
export const registerPendingApprovalsRefresher = (refresh: () => void): (() => void) => {
  refresher = refresh;

  return () => {
    if (refresher === refresh) refresher = undefined;
  };
};

// Loads the count again now; does nothing while no poller runs
export const refreshPendingApprovals = (): void => {
  refresher?.();
};

// The id of a request whose queue state changed, as the hub pushed it (ReceiveApprovalQueueChanged)
const queueChangeListeners = new Set<(approvalRequestId: string) => void>();

// A screen that shows approvals (the queue, one approval) reads them again on a pushed change; returns the unsubscribe
export const subscribeApprovalQueueChanges = (listener: (approvalRequestId: string) => void): (() => void) => {
  queueChangeListeners.add(listener);

  return () => {
    queueChangeListeners.delete(listener);
  };
};

export const notifyApprovalQueueChanged = (approvalRequestId: string): void => {
  queueChangeListeners.forEach((listener) => listener(approvalRequestId));
};
